<template>
	<el-container :style="{'height':yeheight}" style=" border: 1px solid #eee;padding: 3px;">
		<el-aside width="200px" style="background-color: rgb(255,255,255)">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
			<el-tree class="filter-tree" :data="treedata" :props="defaultProps" :filter-node-method="filterNode"
				ref="tree"  @node-click="nodeClick">
			</el-tree>
		</el-aside>
		<el-container>
			<el-header style="text-align: right; font-size: 12px;height: 30px;padding-right: 2px;">
				<div style="float: left;margin-right: 10px;">
					<span>下单类型：</span>
					<el-select size="mini" v-model="value" placeholder="请选择" style="width:100px" @change="quanxian">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div style="float: left;">
					<el-input size="mini" placeholder="请输入内容" v-model="input1" clearable class="input-with-select"
						style="width: 200px;margin-right: 10px;" @keyup.enter.native="search"></el-input>
					<el-button size="mini" icon="el-icon-search" @click="search">查 询</el-button>
				</div>
				<div style="float: right;">

					<el-button size="mini" type="warning" icon="el-icon-shopping-cart-2" @click="selectDelete">
						批量加入购物车</el-button>


					<el-button size="mini" type="success" icon="el-icon-shopping-cart-2" @click="settlement">购物车结算
					</el-button>
				</div>
			</el-header>
			<el-main
				style="overflow-y: false !important;padding-left: 5px;padding-top: 0px; padding-bottom: 0px;padding-right: 2px;">
				<el-table :row-style="setheigth" :cell-style="setpadding" border size="mini" :stripe="true"
					height="calc(100% - 35px)" :row-class-name="tableRowClassName" ref="pagedata" :data="pagedata"
					@selection-change="handleSelectionChange"
					:header-cell-style="{background:'#5a8642',color:'#ffffff',padding:'0'}">
					<el-table-column type="selection" :selectable='checkboxSelect'></el-table-column>
					<el-table-column prop="F_MainImgCode" label="图片" width="125px" align="center">
						<template slot-scope="scope">
							<a href="javascript:;" @click="handleProductClick(scope.row['F_ProductCode'])"
								style="text-center: center;">
								<el-image
									:src="'http://36.22.191.66:4005/'+scope.row['filepath']+scope.row['filename']+'_78x78.png'"
									class="img">
									<div slot="error">
										<i class="el-icon-picture-outline" style="font-size: 80px;"></i>
									</div>
								</el-image>
							</a>
						</template>
					</el-table-column>
					<el-table-column prop="F_ClassName" label="编码/名称/整件规格/规格型号" align="center" min-width="300px" maxWidth="500px"
						show-overflow-tooltip>
						<template slot-scope="scope">
							<a href="javascript:;" @click="handleProductClick(scope.row['F_ProductCode'])"
								style="text-center: center;">
								<i style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;">{{ scope.row.F_ProductCode }}</i><br>
								<i style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;">{{ scope.row.F_ClassName }}</i><br>
							<i style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;">{{ scope.row.整件规格 }}</i><br>
								<i style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;">{{ scope.row.F_SpecText }}</i><br>
							
							</a>
						</template>
					</el-table-column>
					<el-table-column prop="lv" label="优惠" align="center" min-width="200px" show-overflow-tooltip>
						<template slot-scope="scope">
							<span
								style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;"
								v-if="scope.row.QX_TJ&& value!='QX_QD'">特价起订量为
								{{scope.row.TJsum==''? 0:Math.ceil(scope.row.TJsum/scope.row.F_UnitRate)}}
								件,特价 {{parseFloat(parseFloat(scope.row.TJ_Price).toFixed(2))}} 元</span>
							<div style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;"
								v-else-if="scope.row.QX_QD&& value=='QX_QD'"><span style="display: block"
									v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</span>
							</div>
							<div style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;"
								v-else-if="scope.row.QX_PT&& value=='QX_PT'"><span style="display: block"
									v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{u.lvprice}}元&nbsp;</span>
							</div>
							<!--<div v-else-if="scope.row.QX_QD=='True'&& scope.row.OrderType=='QX_QD'" style="white-space:pre">满{{Math.ceil(u.lvwhere/scope.row.onenum)}}件，特价{{u.lvprice}}元&#10;</div>-->
							<span v-else>无</span>
							<!-- <span v-if="scope.row.QX_TJ&&scope.row.TJsum!=null&& value!='QX_QD'">特价起订量为 {{scope.row.TJsum==''? 0:Math.ceil(scope.row.TJsum/scope.row.F_UnitRate)}} 件,特价 {{parseFloat(parseFloat(scope.row.TJ_Price).toFixed(2))}} 元</span>
							  					<div v-else-if="(scope.row.lvprice!=[]|| scope.row.lvprice!='')&& value=='QX_QD'" style="white-space:pre"><span
							  						 v-for="u in scope.row.lvprice">满{{Math.ceil(u.lvwhere/scope.row.F_UnitRate)}}件，单价{{parseFloat(u.lvprice.toFixed(2))}}元&nbsp;</span></div>
							  					<span v-else>无</span> -->
						</template>
					</el-table-column>

				<!-- 	<el-table-column prop="F_ClassName" label="整件规格/规格型号" align="center" width="160px"
						show-overflow-tooltip>
						<template slot-scope="scope">
							</template>
					</el-table-column> -->
					<el-table-column prop="price" label="单价" align="center" min-width="70px">
						<template slot-scope="scope">
							<span
								style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;">{{parseFloat(scope.row.price).toFixed(2)}}</span>
						</template>
					</el-table-column>
					<el-table-column label="件数" min-width="119px" align="center">
						<template slot-scope="scope">
							<el-input-number precision="0" v-model="scope.row.num" :min="1" :max="99999" size="mini"
								style="width: 95px;margin-top: 0px;!important;font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000 !important;"
								@change="numprice(scope.row)">
							</el-input-number>
						</template>
					</el-table-column>
					<!--   <el-table-column label="箱规/当前数量" align="center">
				  <template slot-scope="scope">
				    <i style="font-style: normal;color: #004085;">1件={{ scope.row.F_UnitRate }}{{ scope.row.F_ErpUnitName }}</i><br>
				    &lt;!&ndash;            <i style="font-style: normal;"
				                   v-if="goodsNumss(scope.$index)!=0&&goodsNums(scope.$index)!=0">{{ goodsNums(scope.$index) }}件{{ goodsNumss(scope.$index) }}只</i> &ndash;&gt;
				    <i style="font-style: normal;">{{ scope.row.num * scope.row.F_UnitRate }}{{ scope.row.F_ErpUnitName }}</i>
				    &lt;!&ndash;						<i style="font-style: normal;" v-else-if="goodsNums(scope.$index)==0">{{goodsNumss(scope.$index)}}只</i>&ndash;&gt;
				    &lt;!&ndash;						<i style="font-style: normal;" v-else-if="goodsNumss(scope.$index)==0">{{goodsNums(scope.$index)}}件</i>&ndash;&gt;
				  </template>
				</el-table-column>-->
					<el-table-column prop="TotalNum" label="总数量" align="center" min-width="60px">
						<template slot-scope="scope">
							<span
								style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;">{{ parseFloat((scope.row.num*scope.row.F_UnitRate).toFixed(2))+scope.row.F_UnitText  }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="TotalMoney" label="总金额" align="center" min-width="100px">
						<template slot-scope="scope">
							<span
								style="font-style:normal;font-size: 12px !important;font-weight: 800px !important;color: #000000;">{{ parseFloat((scope.row.num*scope.row.F_UnitRate*scope.row.price).toFixed(2))  }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="总可用量" label="库存" align="center" min-width="50px">
						<template slot-scope="scope">
							<div v-if="scope.row.总可用量=='有'" style="color:blue;">{{scope.row.总可用量}}</div>
							<div v-else style="color: red;">{{scope.row.总可用量==''? "无":scope.row.总可用量}}</div>
						</template>
					</el-table-column>
					<!--            <el-table-column label="总价" align="center">-->
					<!--              &lt;!&ndash;					<template slot-scope="scope">{{onePrice(scope.$index)|showPrice()}}</template>&ndash;&gt;-->
					<!--              <template slot-scope="scope">-->
					<!--                <i style="font-style: normal;">{{ tableData[scope.$index].F_Num * scope.row.product.F_UnitRate *scope.row.CustPrice|showPrice()}}</i>-->
					<!--              </template>-->
					<!--            </el-table-column>-->
					<el-table-column label="操作" align="center" min-width="70px">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="addCart(scope.$index)">添加</el-button>
							<!-- <el-button size="mini" v-else disabled type="danger" @click="addCart(scope.$index)">加入购物车</el-button> -->
						</template>
					</el-table-column>
				</el-table>
				<el-pagination layout="prev, pager, next,sizes,total, jumper" @size-change="SizeChange"
					@current-change="CurrentChange" :page-sizes="[5,10,20,50, 100,200, 500]" :default-page-size="20"
					:current-page="pagination.page" :page-size="pagination.rows" :total="pagination.records">
				</el-pagination>
				<!-- <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 5px;">
					<span class="num">
						<el-button size="mini" type="danger" icon="el-icon-shopping-cart-2" @click="selectDelete">
							批量加入选中商品至购物车</el-button>

					
					</span>
					<el-button size="mini" type="success" icon="el-icon-shopping-cart-2" @click="settlement">结算
					</el-button>

				
				</el-row> -->
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import $ from 'jquery'
	import request from '@/utils/request'
	export default {
		name: 'index',
		components: {

		},
		data() {
			return {
				yeheight: '500px',
				tableheight: '400px',
				loginType: '1',
				versionIndex: 0,
				keyVal: [],
				keyVals: [],
				t_lv1: null,
				t_lv2: null,
				F_CategoryId: null,
				cartNum: null,
				multipleSelection: [],
				inventory: '',
				firstNum: [],
				loading: true,
				pagedata: [],
				treedata: [],
				defaultProps: {
					children: 'children',
					label: 'label',
				},
				filterText: '',
				rows: 50,
				//总数据条数
				records: '',
				//总页数
				total: '',
				page: 1,
				thisPageInex: 1,
				//一级分类产品选择框
				typeList: [],
				isShow: false,
				oIndex: 'all',
				oIndexs: -1,
				cIndex: '',
				input1: '',
				F_ProductId: '',
				youhui: [],
				youhui2: [],
				youhui3: {},


				options: [{
					value: 'QX_PT',
					label: '普通'
				}, {
					value: 'QX_QD',
					label: '渠道'
				}, {
					value: 'QX_DS',
					label: '电商'
				}, {
					value: 'QX_TJ',
					label: '特价'
				}, 
				// {
				// 	value: 'QX_PJ',
				// 	label: '配件'
				// }, {
				// 	value: 'QX_WL',
				// 	label: '物料'
				// },
				{
					value: 'QX_YT',
					label: '阳台'
				}
				],
				value: 'QX_PT',
				pagination: {
					//默认每页显示的条数
					rows: 10,
					//默认显示第一页
					page: 1,
					//总数据条数
					records: 0,
					//总页数
					total: 5,
					sidx: "F_CreateDate",
					sord: "desc"
				},
				productVisible: false,
				productid: '',

				formdata: {},
				list: [],
				spec: [],
				imageIndex: 0,
				versionproIndex: 0,
				images: [],
				keyVal: '',
				num: 0,
			}
		},
		created() {
			this.yeheight = (document.documentElement.clientHeight - 80) + "px"
			window.onresize = () => {
				this.yeheight = (document.documentElement.clientHeight - 80) + "px"
			}
			this.tableheight = (document.documentElement.clientHeight - 380) + "px"
			//this.getTypeList()
			this.loadData()
			this.loadDatatree()
		},
		watch: {
			"filterText": function(val) {

				this.$refs.tree.filter(val)
			},
			"F_CategoryId": function() {
				if (this.t_lv1 == '10') {
					this.value = 'QX_WL'
				} else if (this.t_lv1 == '6' || this.t_lv1 == '7' || this.t_lv1 == '8' || this.t_lv1 == '9') {
					this.value = 'QX_PJ'
				} else {
					this.value = 'QX_PT'
				}
				this.pagination.page = 1
				this.loadData()
			},
			/*"pagedata.num":function (){
			  if(num)
			    scope.row.lvprice[0].cinvcode!=''&&scope.row.num>=Number(u.lvwhere)
			}*/
		},
		methods: {
			setheigth(){
			return	{height:'80px'};
			},
			setpadding(){
			return	{padding:'0px'};
			},
			nodeClick(data) {
			
				//let node = this.$refs.tree.getNode(data);
					//console.log(data.id);
					this.F_CategoryId=data.id;
					this.loadData();
				// if (node.checked) {
					
				// 	undefined
				// 	this.parentNodesChange(node);
				// } else {
				// 	undefined
				// 	this.childNodesChange(node);
				// }
},
			filterNode(value, data) {
				if (!value) return true
				return data.label.indexOf(value) !== -1
			},
			tableRowClassName(row, rowIndex) {
				if (rowIndex % 2 == 0) {
					return 'warning-row'
				} else if (rowIndex == 1) {
					return 'success-row'
				}
				return ''
			},
			addsimpleCart() {
				var productid = this.formdata.存货编码
				request({
					//url: '/shop/cart/addcart',
					url: 'DRPAPI.ashx?a=addcart',
					method: 'post',
					data: {
						keyValue: this.productid,
						num: this.num,
						proType: this.formdata.商品属性,
						F_UnitPrice: this.formdata.F_UnitPrice,
					}
				}).then(res => {
					if (res.code == "200") {
						this.$message.success("加入购物车成功！")
						request({
							//url: '/shop/cart/GetList',
							url: 'DRPAPI.ashx?a=getcartlist',

							method: 'get'
						}).then(res => {
							this.cartNum = res.data.length
							this.$store.commit('getcount', this.cartNum)
						})
					}
				})
			},
			getproductList() {
				request({
					url: 'DRPAPI.ashx?a=getformdata',
					method: 'get',
					data: {
						keyValue: this.productid
					}
				}).then(res => {
					this.list = res.data.list
					this.lists = res.data.list[0]
					this.images = res.data.picurl
				})
			},
			versionClick(index) {
				request({
					url: 'DRPAPI.ashx?a=getformdata',
					method: 'get',
					data: {
						keyValue: this.productid
					}
				}).then(res => {
					this.formdata = res.data.list[index]
				})

			},
			left() {
				$('#imgsbox').animate({
					scrollLeft: $('#imgsbox').scrollLeft() - 95
				}, 500);
			},
			right() {
				$('#imgsbox').animate({
					scrollLeft: $('#imgsbox').scrollLeft() + 95
				}, 500);
			},
			//大图片移动
			mouseoverImg() {
				$('.mask').css("display", "block");
				$('.big').css("display", "block");
			},
			//大图片移动
			mouseoutImg() {
				$('.mask').css("display", "none");
				$('.big').css("display", "none");
			},
			//大图片移动
			moveImg(e) {
				var preview_img = document.querySelector('.preview_img');
				var mask = document.querySelector('.mask');
				var big = document.querySelector('.big');
				//鼠标在盒子内的坐标
				var x = e.pageX - $('.preview_img').offset().left;
				var y = e.pageY - $('.preview_img').offset().top;
				//遮罩层初始位置
				var maskX = x - mask.offsetWidth / 2;
				var maskY = y - mask.offsetHeight / 2;
				// 遮挡层的最大移动距离
				var maskMax = preview_img.offsetWidth - mask.offsetWidth;
				if (maskX <= 0) {
					maskX = 0;
				} else if (maskX >= maskMax) {
					maskX = maskMax;
				}
				if (maskY <= 0) {
					maskY = 0;
				} else if (maskY >= maskMax) {
					maskY = maskMax;
				}
				mask.style.left = maskX + 'px';
				mask.style.top = maskY + 'px';
				var bigIMg = document.querySelector('.bigImg');
				// 大图片最大移动距离
				var bigMax = bigIMg.offsetWidth - big.offsetWidth;
				// 大图片的移动距离 X Y
				var bigX = maskX * bigMax / maskMax;
				var bigY = maskY * bigMax / maskMax;
				bigIMg.style.left = -bigX + 'px';
				bigIMg.style.top = -bigY + 'px';

			},
			//关闭对话框
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			//权限
			quanxian(val) {
				this.value = val
				this.pagination.page = 1
				this.loadData()
			},
			//优惠价格
			numprice(val) {
				// if (Math.floor( val.num) == 0) {
				// 	val.num = 1
				// }	
				// if (val.num  % 1 != 0) {
				// 		this.$message.error("件数只能输入整数!")
				// 		val.num = Math.floor(val.num );
				// 	}
				// 	//alert(val.TotalNum,val.F_UnitRate)
				// 	//val.num = val.TotalNum / val.F_UnitRate
				// alert(val.num);
				var sum = val.num * val.F_UnitRate
				if (val.QX_TJ && val.TJsum != null) {

					if (this.value == "QX_TJ" && sum < val.TJsum) {
						/*this.value = 'QX_PT'
						val.price=val.PT_Price*/
						// this.$confirm("该商品特价起订量为" + Math.ceil(val.TJsum/val.F_UnitRate) + '件，是否将下单类型转为普通', '提示', {
						// 	confirmButtonText: '转成普通',
						// 	cancelButtonText: '取消',
						// 	type: 'warning'
						// }).then(() => {
						// 	this.value = 'QX_PT'
						// 	val.price=val.PT_Price
						// 	//this.count()
						// }).catch(() => {
						// 	val.price=val.PT_Price
						// 	//this.count()
						// });
						this.value = 'QX_PT'
						val.price = val.PT_Price
						//this.$message.error("该商品特价起订量为" + val.TJsum + '，已为您将下单类型转为普通')
					} else if (this.value == "QX_PT" && sum >= val.TJsum) {
						this.$confirm('该商品拥有特价，特价起订量为' + Math.ceil(val.TJsum / val.F_UnitRate) + '件，是否需要将下单类型转成特价?',
							'提示', {
								confirmButtonText: '转成特价',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
							this.value = 'QX_TJ'
							val.price = val.TJ_Price
							//this.count()
						}).catch(() => {
							val.price = val.PT_Price
							//this.count()
						});
					} else if (this.value == "QX_TJ" && sum >= val.TJsum) {
						val.price = val.TJ_Price
					}

				}

				if (this.value == "QX_QD") {
					val.price = val.QD_Price
					for (var j = val.lvprice.length - 1; j >= 0; j--) {
						//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
						if (val.num >= Math.ceil(val.lvprice[j].lvwhere / val.F_UnitRate)) {
							val.price = val.lvprice[j].lvprice
							break;
						}
					}
				}
				if (this.value == "QX_PT") {
					val.price = val.PT_Price
					for (var j = val.lvprice.length - 1; j >= 0; j--) {
						//this.tableData[index].F_Num >= Math.ceil(this.tableData[index].lvprice[j].lvwhere/this.tableData[index].F_UnitRate)
						if (val.num >= Math.ceil(val.lvprice[j].lvwhere / val.F_UnitRate)) {
							val.price = val.lvprice[j].lvprice
							break;
						}
					}
				}

			},
			//多选框库存不足禁用
			checkboxSelect(row, rowIndex) {
				if (row.F_Stock == 0) {
					return true // 禁用
				} else {
					return true // 不禁用
				}
			},
			//加入购物车
			addCart(index, i) {
				this.keyVal = this.pagedata[index].F_ProductId
				// this.keyVals = this.pagedata[index].F_ProductId,

				var protype = "普通";
				for (var i = 0; i < this.options.length; i++) {
					if (this.options[i].value == this.value) {
						protype = this.options[i].label
						break;
					}
				}
				request({
					url: '/DRPAPI.ashx?a=addcart',
					//url: '/shop/cart/addcart',
					method: 'post',
					data: {
						keyValue: this.keyVal,
						num: this.pagedata[index].num,
						proType: protype,
						F_UnitPrice: this.pagedata[index].price,
					}
				}).then(res => {
					if (res.code == "200") {
						this.$message.success("加入购物车成功！")
						localStorage.setItem('value', JSON.stringify(this.value));
						request({
							//url: '/shop/cart/GetList',
							url: 'DRPAPI.ashx?a=getcartlist',
							method: 'get',
							data: {
								keyValue: "",
								num: this.pagedata[i].num,

							}
						}).then(res => {
							this.cartNum = res.data.length
							this.$store.commit('getcount', this.cartNum)

						})
					}
				})
			},
			/* 批量加入购物车 */
			selectDelete(index) {
				if (this.multipleSelection.length === 0) {
					this.$message.error('请选择要加入的商品！')
				} else {
					this.$confirm('确定加入该商品？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(res => {
						let array = []
						for (var i in this.multipleSelection) {
							array.push(this.multipleSelection[i]["F_ProductId"])
						}
						var protype = "普通";
						for (var i = 0; i < this.options.length; i++) {
							if (this.options[i].value == this.value) {
								protype = this.options[i].label
								break;
							}
						}
						for (var i = 0; i < array.length; i++) {
							request({
								url: '/shop/cart/addcart',
								method: 'post',
								data: {
									keyValue: array[i],
									num: this.pagedata[i].num,
									proType: protype
								}
							}).then(res => {
								if (res.code == "200") {
									this.$message.success("加入购物车成功！")
									localStorage.setItem('value', JSON.stringify(this.value));
									request({
										//url: '/shop/cart/GetList',
										url: 'DRPAPI.ashx?a=getcartlist',
										method: 'get'
									}).then(res => {
										this.cartNum = res.data.length
										this.$store.commit('getcount', this.cartNum)
									})
								}
							})
						}

					})
				}
			},
			handleSelectionChange(row) {
				this.multipleSelection = row;
			},
			//切换
			cut() {
				if (this.loginType === '1') {
					this.loginType = '2'
				} else {
					this.loginType = '1'
				}
			},
			getList() {
				//获取商品分类
				this.loading = true
				request({
					//url: '/Drp/ProductCategory/GetTree',
					url: '/DRPAPI.ashx?a=GetTree',
					method: 'get',
					data: {
						parentId: 0
					}
				}).then(res => {

					this.typeList = res.data
					this.page = 1

					//获取商品列表
					request({
						url: '/DRPAPI.ashx?a=getpagelist',
						method: 'get',
						data: {
							pagination: JSON.stringify({
								rows: this.pagination.rows,
								page: this.pagination.page
							}),
							queryJson: JSON.stringify({
								keyword: this.input1,
								F_CategoryId: null,
								quanxian: this.value
							})
						}
					}).then(res => {
						if (res.code == 200) {
							this.loading = false
							this.pagedata = res.data.rows
							this.$nextTick(function() {
								this.pagination.total = res.data.total
								this.pagination.records = res.data.records

							})

							var adddata = "";
							this.pagedata.forEach(item => {
								adddata += item.F_ProductCode + '@'
								if (item.F_Stock === null) {
									this.$set(item, "num", 0)
								} else {
									this.$set(item, "num", 1)
								}
							})
							adddata = adddata.substring(0, adddata.length - 1)
							request({
								url: '/DRPORDERAPI.ashx?a=getstock',
								method: 'post',
								data: {
									F_ProductId: adddata,
									F_CustomerId: this.$store.state.user.F_CustomerId,
								}
							}).then(res => {

								for (var j = 0; j < this.pagedata.length; j++) {
									for (var i = 0; i < res.data.length; i++) {
										if (this.pagedata[j].F_ProductCode == res.data[i]
											.cinvcode) {
											this.pagedata[j].总可用量 = res.data[i].stock
										}

									}
								}

							})


							if (this.value == "QX_QD" || this.value == "QX_PT") {
								request({
									url: '/DRPORDERAPI.ashx?a=getlvpriceinfo',
									method: 'post',
									data: {
										F_ProductId: adddata,
										F_CustomerId: this.$store.state.user.F_CustomerId,
										OrderType: this.value
									}
								}).then(res => {
									for (var j = 0; j < this.pagedata.length; j++) {
										this.pagedata[j].lvprice = []
										for (var i = 0; i < res.data.length; i++) {
											if (this.pagedata[j].F_ProductCode == res.data[i]
												.cinvcode) {
												this.pagedata[j].lvprice.push(res.data[i])
											}

										}
									}

									if (this.value == "QX_QD") {
										for (var i = 0; i < this.pagedata.length; i++) {
											for (var j = 0; j < this.pagedata[i].lvprice
												.length; j++) {
												if (this.pagedata[i].lvprice[j].lvwhere != '' &&
													this.pagedata[i].num >= Math.ceil(this
														.pagedata[i].lvprice[j].lvwhere / this
														.pagedata[i].F_UnitRate)) {
													this.pagedata[i].price = this.pagedata[i]
														.lvprice[j].lvprice
													break
												} else if (this.pagedata[i].num < Math.ceil(this
														.pagedata[i].lvprice[j].lvwhere / this
														.pagedata[i].F_UnitRate)) {
													this.pagedata[i].price = this.pagedata[i]
														.QD_Price
													break
												}
											}
										}
									}
									if (this.value == "QX_PT") {
										for (var i = 0; i < this.pagedata.length; i++) {
											for (var j = 0; j < this.pagedata[i].lvprice
												.length; j++) {
												if (this.pagedata[i].lvprice[j].lvwhere != '' &&
													this.pagedata[i].num >= Math.ceil(this
														.pagedata[i].lvprice[j].lvwhere / this
														.pagedata[i].F_UnitRate)) {
													this.pagedata[i].price = this.pagedata[i]
														.lvprice[j].lvprice
													break
												} else if (this.pagedata[i].num < Math.ceil(this
														.pagedata[i].lvprice[j].lvwhere / this
														.pagedata[i].F_UnitRate)) {
													this.pagedata[i].price = this.pagedata[i]
														.PT_Price
													break
												}
											}
										}
									}
								})
							}
							if (this.value == 'QX_TJ') {
								for (var i = 0; i < this.pagedata.length; i++) {
									if (this.pagedata[i].TJsum > (this.pagedata[i].F_UnitRate * this
											.pagedata[i].num)) {
										this.pagedata[i].price = this.pagedata[i].PT_Price
									} else {
										this.pagedata[i].price = this.pagedata[i].TJ_Price
									}
								}
							}
						}
						// res.data.rows.forEach(item => {
						//   this.pagedata.F_ProductId=item.F_ProductId
						// })
						this.loading = false
					})
				})
			},
			loadDatatree() {
				// request({
				// 	contentType: 'application/x-www-form-urlencoded;charset=UTF-8', //这个参数也是header参数
				// 	//url: '/Drp/ProductCategory/GetTree',
				// 	url: '/DRPAPI.ashx?a=GetTree',
				// 	method: 'get',
				// 	data: {
				// 		parentId: 0
				// 	}
				// }).then(res => {
				// 	this.typeList = res.data

				// })
				request({
					contentType: 'application/x-www-form-urlencoded;charset=UTF-8', //这个参数也是header参数
					//url: '/shop/product/getpagelist',
					url: '/DRPAPI.ashx?a=getpagetreelist',
					method: 'get',
					 	data: {
					 		parentId: 0
					 	}
				}).then(res => {
					console.log(res);
					if (res.code == 200) {
						
						this.treedata = res.data
					}
				})
			},
			loadData() {

				//获取商品列表
				this.loading = true

				request({
					//url: '/shop/product/getpagelist',
					url: '/DRPAPI.ashx?a=getpagelist',
					method: 'get',
					data: {
						pagination: JSON.stringify({
							rows: this.pagination.rows,
							page: this.pagination.page
						}),
						queryJson: JSON.stringify({
							keyword: this.input1,
							F_CategoryId: this.F_CategoryId,
							quanxian: this.value
						})
					}
				}).then(res => {
					if (res.code == 200) {
						this.loading = false
						this.pagedata = res.data.rows
						this.$nextTick(function() {
							this.pagination.total = res.data.total
							this.pagination.records = res.data.records
						})

						var adddata = "";
						this.pagedata.forEach(item => {
							adddata += item.F_ProductCode + '@'
						})
						adddata = adddata.substring(0, adddata.length - 1)
						request({
							url: '/DRPORDERAPI.ashx?a=getstock',
							method: 'post',
							data: {
								F_ProductId: adddata,
								F_CustomerId: this.$store.state.user.F_CustomerId,
							}
						}).then(res => {

							for (var j = 0; j < this.pagedata.length; j++) {
								for (var i = 0; i < res.data.length; i++) {
									if (this.pagedata[j].F_ProductCode == res.data[i].cinvcode) {
										this.pagedata[j].总可用量 = res.data[i].stock
									}

								}
							}

						})
						if (this.value == "QX_QD" || this.value == "QX_PT") {
							request({
								url: '/DRPORDERAPI.ashx?a=getlvpriceinfo',
								method: 'post',
								data: {
									F_ProductId: adddata,
									F_CustomerId: this.$store.state.user.F_CustomerId,
									OrderType: this.value
								}
							}).then(res => {
								for (var j = 0; j < this.pagedata.length; j++) {
									this.pagedata[j].lvprice = []
									for (var i = 0; i < res.data.length; i++) {
										if (this.pagedata[j].F_ProductCode == res.data[i].cinvcode) {
											this.pagedata[j].lvprice.push(res.data[i])
										}
									}
									
								}
								
								if (this.value == "QX_QD") {
									for (var i = 0; i < this.pagedata.length; i++) {
										for (var j = 0; j < this.pagedata[i].lvprice
											.length; j++) {
											if (this.pagedata[i].lvprice[j].lvwhere != '' &&
												this.pagedata[i].num >= Math.ceil(this
													.pagedata[i].lvprice[j].lvwhere / this
													.pagedata[i].F_UnitRate)) {
												this.pagedata[i].price = this.pagedata[i]
													.lvprice[j].lvprice
												break
											} else if (this.pagedata[i].num < Math.ceil(this
													.pagedata[i].lvprice[j].lvwhere / this
													.pagedata[i].F_UnitRate)) {
												this.pagedata[i].price = this.pagedata[i]
													.QD_Price
												break
											}
										}
									}
								}
								if (this.value == "QX_PT") {
									for (var i = 0; i < this.pagedata.length; i++) {
										for (var j = 0; j < this.pagedata[i].lvprice
											.length; j++) {
											if (this.pagedata[i].lvprice[j].lvwhere != '' &&
												this.pagedata[i].num >= Math.ceil(this
													.pagedata[i].lvprice[j].lvwhere / this
													.pagedata[i].F_UnitRate)) {
												this.pagedata[i].price = this.pagedata[i]
													.lvprice[j].lvprice
												break
											} else if (this.pagedata[i].num < Math.ceil(this
													.pagedata[i].lvprice[j].lvwhere / this
													.pagedata[i].F_UnitRate)) {
												this.pagedata[i].price = this.pagedata[i]
													.PT_Price
												break
											}
										}
									}
								}
								// for (var i = 0; i < this.pagedata.length; i++) {
								// 	for (var j = 0; j < this.pagedata[i].lvprice.length; j++) {
								// 		if (this.pagedata[i].lvprice[j].lvwhere != '' && this.pagedata[i]
								// 			.num >= Math.ceil(this.pagedata[i].lvprice[j].lvwhere / this
								// 				.pagedata[i].F_UnitRate)) {
								// 			this.pagedata[i].price = this.pagedata[i].lvprice[j].lvprice
								// 			break
								// 		} else if (this.pagedata[i].num < Math.ceil(this.pagedata[i]
								// 				.lvprice[j].lvwhere / this.pagedata[i].F_UnitRate)) {
								// 			this.pagedata[i].price = this.pagedata[i].QD_Price
								// 			break
								// 		}
								// 	}
								// }
							})
						}
					
						if (this.value == 'QX_TJ') {
							for (var i = 0; i < this.pagedata.length; i++) {
								if (this.pagedata[i].TJsum > (this.pagedata[i].F_UnitRate * this.pagedata[i]
										.num)) {
									this.pagedata[i].price = this.pagedata[i].PT_Price
								} else {
									this.pagedata[i].price = this.pagedata[i].TJ_Price
								}
							}
						}


					}
					this.loading = false
				})
			},
			//分页操作
			SizeChange(newsize) {
				this.pagination.rows = newsize
				this.loadData()
			},
			CurrentChange(newpage) {
				this.pagination.page = newpage
				this.loadData()
			},
			getTypeList() {
				//获取商品分类
				request({
					contentType: 'application/x-www-form-urlencoded;charset=UTF-8', //这个参数也是header参数
					//url: '/Drp/ProductCategory/GetTree',
					url: '/DRPAPI.ashx?a=GetTree',
					method: 'get',
					data: {
						parentId: 0
					}
				}).then(res => {
					this.typeList = res.data

				})
			},
			//结算跳转至购物车
			settlement() {
				this.$router.push({
					path: '/procure/cart',
				})
			},
			//跳转至详情页面
			handleProductClick(id) {
				this.productVisible = true
				this.productid = id
				this.getproductList()
				this.versionClick(0)
				this.$router.push({
					path: '/procure/product/detail',
					query: {
						id: id
					}
				})
			},
			//上一页
			leftClick() {
				if (this.page == 1) {
					this.page = 1
				} else {
					this.page = this.page - 1
					this.thisPageInex = this.page
					if (this.cIndex == '') {
						this.getList()
					} else {
						this.getTypeList()
					}
				}



			},
			//下一页
			rightClick() {

				if (this.page < this.total) {
					this.page = this.page + 1
					this.thisPageInex = this.page
					if (this.cIndex == '') {
						this.getList()
					} else {
						this.getTypeList()
					}
				} else {
					this.page = this.page
					if (this.cIndex == '') {
						this.getList()
					} else {
						this.getTypeList()
					}
				}

			},
			//点击页数
			changeBg(index) {
				this.page = index
				if (this.cIndex == '') {
					this.getList()
				} else {
					this.getTypeList()
				}

			},
			//选择所有产品
			selectAll() {
				//this.isShow = false
				this.F_CategoryId = null
				this.oIndex = 'all'
				this.cIndex = ''
				this.page = 1
				this.thisPageInex = 1
				this.getList()
			},
			//选择相对应的产品分类(一级)
			selectProduct(i, id) {
				//this.isShow = true
				this.F_CategoryId = id
				//this.oIndex = i
				// this.cIndex = i
				this.page = 1
				this.thisPageInex = 1
				this.oIndexs = -1
				this.getTypeList()
			},
			//选择相对应的产品分类(二级)
			selectNextProduct(i, id) {
				this.F_CategoryId = id
				this.oIndex = i
				this.cIndex = i
				this.page = 1
				this.thisPageInex = 1
				this.oIndexs = -1
				this.getTypeList()
			},
			//模糊查询
			search() {
				this.pagination.page = 1
				if (this.cIndex == '') {
					this.page = 0
					this.getList()
				} else {
					this.page = 0
					this.getTypeList()
				}
			}
		},
		computed: {
			totals: function() {
				//开始的数字
				var left = 1;
				//结束的数字
				var right = this.total;
				//存储返回值
				var ar = [];
				//一行显示的个数
				var condition = 5;
				//中间的数字
				var middle = Math.ceil(condition / 2);
				if (this.total >= condition) {
					if (this.page > middle && this.page < this.total - (middle - 1)) {
						left = this.page - (middle - 1)
						right = this.page + (middle - 1)
					} else {
						if (this.page <= middle) {
							left = 1
							right = condition
						} else {
							right = this.total
							left = this.total - (condition - 1)
						}
					}
				}
				while (left <= right) {
					ar.push(left)
					left++
				}
				return ar

			}
		},
		filters: {
			showPrice(price) {
				if (!price) return '0.00';
				var intPart = Number(price) - Number(price) % 1; //获取整数部分
				var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

				var floatPart = ".00"; //预定义小数部分
				var value2Array = price.toString().split(".");

				//=2表示数据有小数位
				if (value2Array.length == 2) {
					floatPart = value2Array[1].toString(); //拿到小数部分

					if (floatPart.length == 1) {
						return '¥' + intPartFormat + "." + floatPart + '0';
					} else {
						return '¥' + intPartFormat + "." + floatPart.substring(0, 2);
					}
				} else {
					return '¥' + intPartFormat + floatPart;
				}
			},
			getF_DiscountType(data) {
				var t = ""
				switch (data) {
					case 1:
						t = "打折"
						break;
					case 2:
						t = "减价"
						break;
					case 3:
						t = "固定价格"
						break;
					case 4:
						t = "满赠商品"
						break;
					default:
						t = ""
				}
				return t
			}
		}
	}
</script>
<style>
	.el-table--striped .el-table__body tr.el-table__row--striped td {
		background: #eeeeee;
	}

	.el-table td,
	.el-table th.is-leaf {
		border: 1px solid #CCCCCC;
		/* border-right:  #CCCCCC;
			  border-left: 1px solid #CCCCCC; */
	}

	.el-table__body .el-table .cell {
		color: #000000;

	}

	.el-pagination {
		border: 1px solid #CCCCCC;

	}

	.el-table__header {
		/* border-top: 1px solid #CCCCCC; 
		border-left: 1px solid #CCCCCC;
		border-right: 1px solid #CCCCCC; */
	}

	.el-tree filter-tree {
		color: #000000;
		font-size: 16px !important;
	}

	.el-table__row {
		height: 25px !important;

	}
</style>
<style scoped>
	@import "../../font/iconfont.css";

	@font-face {
		font-family: 'iconfont';
		src: url('../../font/iconfont.eot');
		src: url('../../font/iconfont.eot?#iefix') format('embedded-opentype'),
			url('../../font/iconfont.woff2') format('woff2'),
			url('../../font/iconfont.woff') format('woff'),
			url('../../font/iconfont.ttf') format('truetype'),
			url('../../font/iconfont.svg#iconfont') format('svg');
	}

	.el-table .warning-row {
		el-table-tr-background-color: red;
	}

	.el-table .success-row {
		el-table-tr-background-color: var(el-color-success-lighter);
	}

	.iconfont {
		font-family: "iconfont" !important;
		font-size: 12px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.tButton {
		margin: 0 8px 8px 0;
		font-size: 12px;
		background-color: white;
		border: 1px solid #eeeeee;
		padding: 5px 10px;
		cursor: pointer;
	}

	.oIndex {
		color: white;
		font-weight: 700;
		background-color: #409EFF;
	}

	.oIndexs {
		color: white;
		font-weight: 700;
		background-color: #409EFF !important;
	}

	.sure {
		color: white;
		font-weight: 700;
		background-color: #409EFF !important;
	}

	.icon {
		width: 1em;
		height: 1em;
		vertical-align: -0.15em;
		fill: currentColor;
		overflow: hidden;
	}

	.imgbox {
		height: 80px;
		display: flex;
		justify-content: center;
	}

	.dbtn {
		height: 80px;
		width: 44px;
		border: 1px solid #EEEEEE;
		font-size: 28px;
		color: #c1c1c1;
		text-align: center;
		line-height: 80px;
		cursor: pointer;
	}

	.imgsbox {
		white-space: nowrap;
		overflow: hidden;
		height: 80px;
		width: 480px;
	}

	.ins {
		display: inline-block;
		height: 80px;
		width: 80px;
		border: 1px solid #EEEEEE;
		margin: 0 6px;
	}

	.ins :hover {
		border: 1px solid #ec595c;
	}

	.version_box {
		margin-left: 15px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		width: 516px;
	}

	.product_version {
		padding: 3px 9px 3px 1px;
		line-height: 30px;
		border: 1px solid #EEEEEE;
		cursor: pointer;
		margin: 0 7px 10px 0;
		font-size: 14px;

	}

	.active2 {
		border: 2px solid #ec595c !important;
		position: relative;
	}

	.i {
		display: block;
		position: absolute;
		border-bottom: 14.5px solid #ec595c;
		border-left: 1.1rem solid transparent;
		width: 0px;
		height: 0px;
		bottom: 0rem;
		right: 0;
	}

	.i:after {
		position: absolute;
		content: '\2714';
		color: #fff;
		left: -0.8rem;
		top: -0.4rem;
		font-size: 1.2rem;
	}

	.a .el-breadcrumb__inner {
		color: #0081ff !important;
		font-weight: 700 !important;
	}

	.preview_img {
		position: relative;
		max-width: 410px;
		margin: 10px auto;
		text-align: center;
	}

	.mask {
		display: none;
		position: absolute;
		top: 0;
		left: 0;
		width: 280px;
		height: 280px;
		background: #FEDE4F;
		opacity: .5;
		border: 1px solid #ccc;
		cursor: move;
	}

	.big {
		display: none;
		position: absolute;
		left: 410px;
		top: 0;
		width: 496px;
		height: 496px;
		background-color: whitesmoke;
		z-index: 999;
		border: 1px solid #ccc;
		overflow: hidden;
	}

	.diaimg {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-left: -205px;
		margin-top: -205px;
		vertical-align: middle !important;
	}

	.big img {
		position: absolute;
		top: 0;
		left: 0;

	}

	.img {
		width: 87px;
		height: 87px;
	}

	.el-image__inner {
		width: auto;
	}

	.el-button--mini {
		padding: 5px 10px !important;
	}

	.el-table .cell {
		line-height: 2 !important;
	}

	.el-input-number__increase {
		width: 29px !important;
		/* height: 50px; */
		font-size: 24px !important;
	}

	.el-table__row--striped {
		background-color: #001D2A !important;

	}

	.el-card__body {
		padding: 5px !important;

	}
</style>
